import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { MarkdownService } from 'ngx-markdown';
import { EnlacesService } from 'src/app/components/empresa/empresa-generador-enlace/enlaces-service/enlaces.service';
import { SuscripcionesService } from 'src/app/components/suscripciones/suscripciones.service';
import { FormatterService } from '../formatter/formatter.service';
import { SentryService } from '../sentry/sentry.service';
import { SesionService } from '../sesion/sesion.service';
import { SocketService } from '../socket/socket.service';

@Component({
  selector: 'app-suscripcion-redirect',
  templateUrl: './suscripcion-redirect.component.html',
  styleUrls: ['./suscripcion-redirect.component.scss']
})
export class SuscripcionRedirectComponent implements OnInit {

  empresaID = 0;
  paisID = 46;
  periodo = '';
  plan = '';
  montoParcial = 0;
  url = '';
  email: string = '';
  data: any;
  enlaceGenerado: string | null = null
  md: string = '';

  get planFormateado(): string {
    switch (this.plan) {
      case 'FILTRO_X': return 'Filtro X';
      case 'ACELERA': return 'Acelera+';
      case 'TURBO': return 'Turbo';
      default: return 'Filtro X';
    }
  }

  get intervaloPlanFormateado(): string {
    switch (this.periodo) {
      case 'DIARIO': return 'Diario';
      case 'MENSUAL': return 'Mensual';
      case 'ANUAL': return 'Anual';
      default: return 'Mensual';
    }
  }

  get esPaisChile(): boolean {
    return this.sesionService.esPaisChile(this.paisID ? this.paisID : this.sesionService.usuario.pais_id);
  }

  get currency(): string {
    return this.esPaisChile ? '$' : 'USD $';
  }

  constructor(
    private http: HttpClient,
    private mdService: MarkdownService,
    private router: Router,
    private route: ActivatedRoute,
    private sesionService: SesionService,
    public formatter: FormatterService,
    private sentryService: SentryService,
    private socketService: SocketService,
    private service: SuscripcionesService,
    private loading: LoadingService,
    private alerts: AlertService,
    private enlaceServices: EnlacesService
  ) { }

  ngOnInit(): void {
    this.readParams();
  }

  readParams(): void {
    this.route.queryParams.subscribe(params => {
      if (params['link']) {
        this.enlaceGenerado = params['link']
      }
      if (params['payload']) {
        this.data = JSON.parse(atob(params['payload']));
        if (this.data.empresaID) this.empresaID = this.data.empresaID;
        if (this.data.paisID) this.paisID = this.data.paisID;
        if (this.data.tipo) this.periodo = this.data.tipo;
        if (this.data.plan) this.plan = this.data.plan;
        if (this.data.montoParcial) this.montoParcial = this.data.montoParcial;
        if (this.data.email) this.email = this.data.email;
        if (this.data.url) this.url = this.data.url;
      }
      (!this.enlaceGenerado) ? this.abrirEnlacePago() : this.abrirEnlaceGenerado();
    });
  }

  abrirEnlacePago(): void {
    this.socketService.startConnection(null);
    if (this.url) {
      window.open(this.url);
      return;
    }
    this.loading.show();
    const data = {
      empresa_id: this.empresaID,
      intervalo: this.periodo,
      plan: this.plan,
      productos: ['LUBRIKUV'],
      monto_parcial: this.montoParcial,
    };
    this.service.getEnlacePagoEnlaceExterno(this.empresaID ? this.empresaID : this.sesionService.user.empresa_id, this.paisID, data).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.url = res.url;
        window.open(this.url);
      },
      error: (err: any) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert(err.error?.msg ?? "Error al obtener el enlace de Pago.", "danger");
        this.sentryService.captureException(err.error);
      }
    });
  }

  abrirEnlaceGenerado() {
    if (this.enlaceGenerado) {
      this.loading.show()
      this.enlaceServices.viewEnlace(this.enlaceGenerado).subscribe({
        next: (res: any) => {
          this.loading.hide();
          window.open(res, "_blank");
        }, error: (err: any) => {
          this.loading.hide();
          if (err.response) this.alerts.addAlert(err.response, 'danger');
          if (err.error.response) this.alerts.addAlert(err.error.response, 'danger')
          if (err.error.msg) this.alerts.addAlert(err.error.msg, 'danger');
        }
      });

      return;
    }
  }

}
